export default function toggleAnswer() {
	var toggleAnswerButton = document.getElementsByClassName("qa__card-toggle");

	for (var i = 0; i < toggleAnswerButton.length; i++) {
		toggleAnswerButton[i].addEventListener("click", function() {

			if (!this.className.includes('active')) {
				this.className += " active";
			} else {
				this.classList.remove('active');
			}
		});
	}
}
